// extracted by mini-css-extract-plugin
module.exports = {"sponsorTrigger":"siteNav_sponsorTrigger__LEku4"};